import { Stack, Typography } from '@mui/material';

export interface ICountWithTextCard {
  count: string | number;
  text: string;
  fullHeight?: boolean;
  variant?: 'h2' | 'h3' | 'h4';
}

const CountWithTextCard = ({
  count,
  text,
  fullHeight = false,
  variant = 'h3',
}: ICountWithTextCard) => (
  <Stack
    direction="column"
    textAlign="center"
    style={{ height: fullHeight ? '100%' : 'auto' }}
    justifyContent="center"
  >
    <Typography variant={variant} display="flex" justifyContent="center">
      {count}
    </Typography>
    <Typography variant="h6">{text}</Typography>
  </Stack>
);

export default CountWithTextCard;
